import type {
  BaseApiOptionParams,
  QsAxiosRequestConfig,
  QsAxiosResponseHeaders,
} from '@shared/util/request'
import { BaseApiOptions, genRequest } from '@shared/util/request'
import type { AxiosResponse } from 'axios'
import { route } from '@/router/util'
import { $error } from '@/plugins/toaster'
import { useUserStore } from '@/store/user'
import { getUrl, gotoLogin } from '@/router/util.redirect'
import { LayoutEventTypes, layoutEventBus } from '@/utils/layout-provider'

const MOCK_ENABLE = import.meta.env.DEV && import.meta.env.VITE_MOCK_ENABLE === 'true'
const MOCK_ALL = MOCK_ENABLE && import.meta.env.VITE_MOCK_ALL === 'true'

interface IThesisBaseApiOptionParams extends BaseApiOptionParams {
  symbol?: string
}

export class ApiOptions extends BaseApiOptions {
  symbol: string
  constructor(option: IThesisBaseApiOptionParams) {
    super(option)
    this.symbol = option.symbol || ''
    this.mock = MOCK_ALL || (MOCK_ENABLE && !!option.mock)
  }

  override get baseUrl() {
    return `${this.mock ? '/mock' : ''}/api/`
  }
}

const REFERER_REDIRECT_MAP: Record<string, string> = {
  '/BindPhone': 'BindPhone',
  '/ForceResetPassword': 'ForceResetPassword',
  '/Login': 'Login',
}
const resolve403 = (referer?: string) => {
  if (referer) {
    if (referer.toLowerCase().includes('login')) {
      useUserStore().logout()
    }
    const refererSuffix = `/${referer.split('/').pop()}`
    if (REFERER_REDIRECT_MAP[refererSuffix]) {
      if (route.value.name !== REFERER_REDIRECT_MAP[referer as string]) {
        location.href = getUrl({ name: REFERER_REDIRECT_MAP[refererSuffix] }, `${import.meta.env.VITE_SITE_URL}${referer}`)
      }
      return
    }
    location.href = referer
  } else if (route.value.name !== 'Home') {
    layoutEventBus.emit({ type: LayoutEventTypes.GO_HOME })
  }
}
const errorHandle = (errorResponse: AxiosResponse): void | Promise<any> => {
  const referer = (errorResponse.headers as QsAxiosResponseHeaders).referer
  switch (errorResponse.status) {
    case 401:
      useUserStore().logout()
      $error('账户信息已失效，请重新登录')
      gotoLogin()
      break

    case 403:
      !(errorResponse.config as QsAxiosRequestConfig).qsArg?.ignore403 && resolve403(referer)
      break
    case 302:
      $error('暂时没有权限操作哦, 正在为您重新导航')
      layoutEventBus.emit({ type: LayoutEventTypes.GO_HOME })
      break
  }
}

const { getRequest, postRequest, getRequestWithCache, clearRequestCache } = genRequest(
  ApiOptions,
  errorHandle,
)
export { getRequest, postRequest, getRequestWithCache, clearRequestCache }
